var map = {
	"./AVAX.svg": "6002",
	"./Arbitrum.svg": "abda",
	"./BNB.svg": "0916",
	"./BorrowAPR.svg": "a3e8",
	"./Close_L.svg": "19ef",
	"./Close_L2.svg": "ab44",
	"./Compeltedicon.svg": "cde3",
	"./Completed-close.svg": "7b44",
	"./CompletedNotificationclose.svg": "73de",
	"./DistributionAPR.svg": "aa26",
	"./ETH.svg": "fda2",
	"./ETHicon.svg": "6bda",
	"./Ellipse2516.svg": "e48d",
	"./FTM.svg": "d99e",
	"./Fill.svg": "b83a",
	"./Fourcircles.svg": "3956",
	"./Frame659.svg": "75b6",
	"./Frame6592.svg": "70f1",
	"./Frame6592S.svg": "a621",
	"./Frame9405.svg": "488f",
	"./Jump.svg": "2ddd",
	"./Jump3.svg": "0396",
	"./Jumpicon2.svg": "240f",
	"./Loginicon.svg": "42b7",
	"./MATIC.svg": "1ec6",
	"./ProtocolIcon.svg": "61a0",
	"./SmallArrow.svg": "86c8",
	"./TX.svg": "ba35",
	"./TX2.svg": "5507",
	"./USDC.svg": "25a8",
	"./Vector310.svg": "d0c7",
	"./back.svg": "0a15",
	"./copy.svg": "d97c",
	"./copy2.svg": "5e64",
	"./copy3.svg": "5e27",
	"./detail-back.svg": "b165",
	"./detail-back2.svg": "ca79",
	"./details.svg": "05cb",
	"./down-icon.svg": "c759",
	"./down.svg": "abe8",
	"./dropdownicon.svg": "78a1",
	"./dropdownicon2.svg": "e36b3",
	"./governicon2.svg": "7de9",
	"./governincn1.svg": "f83f",
	"./iconDown.svg": "329c",
	"./iconUp.svg": "f483",
	"./logo.svg": "4431",
	"./max.svg": "4ac2",
	"./max2.svg": "5d57",
	"./maxG.svg": "1fdc",
	"./moon.svg": "8fad",
	"./moon2.svg": "f184",
	"./new/BorrowList.svg": "7f0d",
	"./new/BorrowList2.svg": "902a",
	"./new/CollateralList.svg": "07b0",
	"./new/CollateralList2.svg": "31ae",
	"./new/TX.svg": "fc94",
	"./new/arrow-down-white.svg": "a73d",
	"./new/arrow-down.svg": "2951",
	"./new/arrow-right.svg": "590a",
	"./new/chain/avax.svg": "2e0b",
	"./new/chain/bsc.svg": "fd58",
	"./new/chain/eth.svg": "e321",
	"./new/chain/ftm.svg": "1a6c",
	"./new/chain/polygon.svg": "4606",
	"./new/directionRight-disabled.svg": "60e0",
	"./new/directionRight-white.svg": "3e3b",
	"./new/directionRight.svg": "9dd3",
	"./new/export.svg": "a3da",
	"./new/filter.svg": "f9c5",
	"./new/grid-dark.svg": "99ed",
	"./new/grid.svg": "26c3",
	"./new/link.svg": "bd40",
	"./new/logo.svg": "7dd3",
	"./new/market-dark.svg": "6c34",
	"./new/market.svg": "8c63",
	"./new/modal/borrow.svg": "b124",
	"./new/modal/repay.svg": "9896",
	"./new/modal/supply.svg": "37b3",
	"./new/modal/txnComplete.svg": "7fa7",
	"./new/modal/txnComplete2.svg": "0de1",
	"./new/modal/txnFailed.svg": "562d",
	"./new/modal/txnNotStarted.svg": "9a7a",
	"./new/modal/txnPending.svg": "52f1",
	"./new/modal/withdraw.svg": "ca15",
	"./new/moon.svg": "fa1b",
	"./new/moon2.svg": "d2a3",
	"./new/question-white.svg": "5fb3",
	"./new/spinner.svg": "6a42",
	"./new/sun.svg": "cddc",
	"./new/sun2.svg": "071b",
	"./new/switch.svg": "bd59",
	"./new/trend-down.svg": "36c3",
	"./new/trend-up.svg": "833b",
	"./polygon.svg": "7f6c",
	"./question.svg": "0101",
	"./question2.svg": "a956",
	"./safflower.svg": "e820",
	"./siginicon.svg": "8198",
	"./sun.svg": "2a85",
	"./sun2.svg": "4e09",
	"./switch.svg": "e162",
	"./switchG.svg": "e2e3",
	"./switchG2.svg": "28e9",
	"./testAVAX.svg": "73b0",
	"./testBNB.svg": "e6d2",
	"./testETH.svg": "110e",
	"./testFTM.svg": "8658",
	"./testMATIC.svg": "d050",
	"./testUSDC.svg": "560a",
	"./unknown.svg": "ef06"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c713";